import { uuidv4 } from "../../../utils/uuid";

/**
 * Hands a survey to Listen's editor: Listen's `/listen/survey/new?key=…` opens the draft stored
 * under `key`. Only the latest draft is kept, as in Listen.
 */
export function storeGeneratedSurvey(survey: unknown): string {
  const key = uuidv4();
  localStorage.setItem("generatedSurvey", JSON.stringify({ [key]: survey }));
  return key;
}
